import Script from 'next/script';

interface GtmScriptProps {
  containerId: string;
}

/**
 * Renders the standard Google Tag Manager snippet. Initialises
 * `window.dataLayer` and loads the GTM container script asynchronously.
 *
 * Rendered before any user-controlled customHeadScripts so our dataLayer
 * declaration wins if a user injects their own `var dataLayer = ...`.
 */
export function GtmScript({ containerId }: GtmScriptProps) {
  return (
    <>
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${containerId}');
          `,
        }}
      />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
}
